export default "__VITE_ASSET__BZ06T6JP__"